module.exports = __webpack_public_path__ + "static/img/no-data-colorful.dfb51b04.png";